module.exports = __webpack_public_path__ + "fonts/Poppins-SemiBold.71da8e4.woff";